import { Cherry, Leaf, Salad, Sandwich } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFilters } from "../../contexts/FilterContext";
import { getPopularCategories } from "../../api/categoryApi";

// Default placeholder categories
const defaultCategories = [
  { name: "Fruits", icon: Cherry, color: "bg-red-100 text-red-600" },
  { name: "Vegetables", icon: Leaf, color: "bg-green-100 text-green-600" },
  { name: "Salads", icon: Salad, color: "bg-emerald-100 text-emerald-600" },
  { name: "Sandwiches", icon: Sandwich, color: "bg-yellow-100 text-yellow-600" },
];

export const Category = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { updateFilter } = useFilters();
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const fetchPopularCategories = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await getPopularCategories();
        if (response.success && response.categories.length > 0) {
          setCategories(response.categories);
        } else {
          setCategories(defaultCategories);
          setError("Using default categories");
        }
      } catch (error) {
        console.error("Error fetching popular categories:", error);
        setCategories(defaultCategories);
        setError("Failed to load popular categories. Showing defaults.");
      } finally {
        setLoading(false);
      }
    };

    fetchPopularCategories();
  }, []);

  const handleCategoryClick = (category) => {
    updateFilter("category", category._id || category.name, {
      categoryName: category.name,
    });
    navigate("/browse");
  };

  return (
    <section className="mb-24">
      <h2 className="text-2xl font-bold mb-8">Browse By Popular Categories</h2>

      {error && <p className="text-sm text-red-500 mb-4">{error}</p>}

      <div
        className={`grid grid-cols-2 md:grid-cols-4 gap-4 transition-all duration-1000 delay-300 transform ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        {categories.slice(0, 4).map((category, index) => {
          // If using defaults, pick icon/color from defaultCategories
          // For database categories, use fallback icon/color based on index
          const fallback = defaultCategories[index % defaultCategories.length];
          const Icon = category.icon || fallback.icon;
          const color = fallback.color;

          return (
            <button
              key={category._id || category.name}
              onClick={() => handleCategoryClick(category)}
              className="group bg-white rounded-xl overflow-hidden border border-border/60 shadow-sm hover:shadow-md transition-all duration-300 p-6 flex flex-col items-center text-center relative"
            >
              <div
                className={`w-12 h-12 mb-4 rounded-full flex items-center justify-center ${color}`}
              >
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="font-medium">{category.name}</h3>
              {/* Show listing count if available and greater than 0 */}
              {/* {category.listingCount > 0 && (
                <span className="absolute top-2 right-2 bg-blue-500 text-white text-xs px-2 py-1 rounded-full">
                  {category.listingCount}
                </span>
              )} */}
            </button>
          );
        })}
      </div>
    </section>
  );
};